import React, { Component } from 'react'
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import { currentTenant, thousandsdisplay, userid } from '../../Common/Credentials'
import moment from 'moment'
import { spin } from '../../Common/NewLoader'
import {NumericFormat} from 'react-number-format';
import MUIDataTable from 'mui-datatables'
import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material";
import SubscriptionServices from './SubscriptionServices.js';
import CustomToolbar from '../../CommonComponents/CustomToolbar.js';
import PaymnetServices from '../../PaymnentGtaeway/PaymnetServices.js';
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';


const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
          border: [[1, 'solid', '#ece6e6']], 
      },
      body:
      {
        border: [[1, 'solid', '#ece6e6']],
      },
    },
  },
});


class Subscriptions extends Component {

  constructor(props) {
    super(props)

    this.state = {
      data: [],
      loading:false,
    }
  }
    
  refresh(){
    SubscriptionServices.GetAllPlans()
      .then(response => {  
          this.setState({ data: response.data})
          this.setState({loading:false})
        }   
    )
    .catch((e)=>{
      if(e.response.data.error ==="Unauthorized"){
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
      }
  })
  }
  
  componentDidMount() {

    if(userid===undefined){
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }
    this.setState({loading:true})

    this.refresh()
  }

  ActiveorInactive = (id)=>{
    SubscriptionServices.updateSubscriptionPlanStatus(id).then(()=>this.refresh())
  }

  Approve=(id)=>{
    console.log(this.state.data.find(e=>e.id===id))
    // let data = {
    //     // if(Enguagment.SAASMonthly.equals(sp.getEnguagmenttype())){
    //     //     planreq.setPeriod("monthly");
    //     // }else if(Enguagment.SAASQuarterly.equals(sp.getEnguagmenttype())) {
    //     //     planreq.setPeriod("quarterly");
    //     // }else if(Enguagment.SAASYearly.equals(sp.getEnguagmenttype())) {
    //     //     planreq.setPeriod("yearly");
    //     // }
    // }
    // PaymnetServices.CreatePlan(data).then(()=>{
    SubscriptionServices.approvesubscriptionplan(id).then(()=>this.refresh())
// })
  }
    
  render() {
let columns=[
    {name: "id",label:"Id",options: {filter: false,sort: false,display:false}},
    {name: "title",label: "Title",options: {filter: true,sort: true,}},
    {name: "description",label: "Description",options: {filter: false,sort: true}},
    {name: "planbenifits",label: "Plan Benifits",options: {filter: false,sort: true,customBodyRender:(tableMeta)=>{
        return(JSON.parse(tableMeta)?.toString())
      }}},
    {name: "enguagmenttype",label: "Enguagment Type",options: {filter: false,sort: true}},
    // {name: "status",label: "Status",options: {filter: false,sort: true, setCellProps: value => ({ style: { textAlign:'center'}})}},
    // {name: "balance",label: "Pending Amount",options: {filter: false,sort: true,
    //   customBodyRender:(tableMeta)=>{
    //     return(<NumericFormat className="pr-3" displayType={'text'} value={tableMeta} decimalScale={2} fixedDecimalScale={true} disabled ={true} thousandSeparator={true} thousandsGroupStyle={thousandsdisplay}></NumericFormat>)
    //   },
    //   setCellProps: value => ({ style: { textAlign:'right'}}),
    // }},
    {name: "createdAt",label: "Date",options: {filter: false,sort: true,sortOrder: 'asc', 
    customBodyRender:(tableMeta)=>{
      return(moment(tableMeta).format('DD-MM-YYYY hh:mm'))
    }}},
    {name: "status",label: "Status",options: {filter: false,sort: true,sortOrder: 'asc', 
        customBodyRender: (value, tableMeta, updateValue) => {
            return <span
            as="button"
            data-tip
            data-for="delete"
            className={`btn btn-sm ${value === "ACTIVE"?"btn-success":"btn-warning"} `}
            onClick={() => this.ActiveorInactive(tableMeta.rowData.find((e) => e))}
          > {value}</span>
          },}},
          {name: "approvestatus",label: "Action",options: {filter: false,sort: true,sortOrder: 'asc', 
            customBodyRender: (value, tableMeta, updateValue) => {
                return <div className="tw-flex tw-gap-2 tw-items-center">{value ==="NO" && <span
                as="button"
                data-tip
                data-for="delete"
                className={`btn btn-sm hovbuttonColour`}
                onClick={() => this.Approve(tableMeta.rowData.find((e) => e))}
              >Approve</span>}
               <Link
                as="button"
                className="btn btn-sm hovbuttonColour"
                to={{pathname: "/subscriptionpackdetails"}}
                  state= {{ id:tableMeta.rowData.find((e) => e) ,data:this.state.data.find(e=>e.id === tableMeta.rowData.find((e) => e)),}}
              >View
              </Link></div>
              },}},      
  ];
   const options = {
    filterType: 'checkbox',
    selectableRows: "none",
    customToolbar: () => {
        return (
          <>
              <Link
                as="button"
                className="float-right btn btn-sm m-0 p-0"
                to={{pathname: "/newsubscriptionpack"}}
                  state= {{ id: -1,data:'',}}
              >
                <CustomToolbar />
              </Link>
          </>
        );
      },
    // setRowProps: row => { 
    //   // if (row[5] === "Pending") {
    //   //   return {
    //   //     style: { background: "#ecf8fb" }
    //   //   };
    //   // }
    // }
  }

    return (
          
      <div>
        
        <Header />
         <Menu/>
        <div className="content-wrapper">  
        <div className='UI-container'>
        <div className="UI-card">
        <div className={`UI-header`}>
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"Subscriptions",path:null}]}/>
        </div>
                    <div className="UI-table-container">
                      <div>{this.state.loading === true ?<div className="text-center">{spin}</div>:
                         <ThemeProvider theme={theme}> 
                        <MUIDataTable
                          className="table-sm "
                          title={"Subscriptions"}
                          data={this.state.data}
                          columns={columns}
                          options={options}
                        />
                        </ThemeProvider>
                      }</div>
                      </div>
                </div>
          </div>
        </div>
        <Footer/>  
      </div>        
    )  
  }  
}
export default withRouter(Subscriptions)